import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bedas_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const mediaUrl = (url) => {
  if (!url) return "";
  return url.startsWith("/api/") ? `${BACKEND_URL}${url}` : url;
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Bir hata oluştu";
};

export const LOGO = "https://customer-assets-m6fa6gv7.emergentagent.net/job_bedding-elite-1/artifacts/y6sz6we9_bedas%20logo%20arka%20plans%C4%B1z.Cdr.png";
